"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _tab = _interopRequireDefault(require("./tab.style"));

var _tags = _interopRequireDefault(require("../../../utils/helpers/tags/tags"));

var _utils = require("../../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TabContext = /*#__PURE__*/_react.default.createContext({});

exports.TabContext = TabContext;
const paddingPropTypes = (0, _utils.filterStyledSystemPaddingProps)(_propTypes2.default.space);

const Tab = ({
  ariaLabelledby,
  className,
  children,
  isTabSelected,
  position = "top",
  role = "tabpanel",
  tabId,
  updateErrors,
  updateWarnings,
  updateInfos,
  href,
  ...rest
}) => {
  const [tabErrors, setTabErrors] = (0, _react.useState)({});
  const [tabWarnings, setTabWarnings] = (0, _react.useState)({});
  const [tabInfos, setTabInfos] = (0, _react.useState)({});
  const setError = (0, _react.useCallback)((childId, hasError) => {
    if (tabErrors[childId] !== hasError) {
      setTabErrors({ ...tabErrors,
        [childId]: hasError
      });
    }
  }, [tabErrors]);
  const setWarning = (0, _react.useCallback)((childId, hasWarning) => {
    if (tabWarnings[childId] !== hasWarning) {
      setTabWarnings({ ...tabWarnings,
        [childId]: hasWarning
      });
    }
  }, [tabWarnings]);
  const setInfo = (0, _react.useCallback)((childId, hasInfo) => {
    if (tabInfos[childId] !== hasInfo) {
      setTabInfos({ ...tabInfos,
        [childId]: hasInfo
      });
    }
  }, [tabInfos]);
  (0, _react.useEffect)(() => {
    if (updateErrors) {
      updateErrors(tabId, tabErrors);
    }
  }, [tabId, tabErrors, updateErrors]);
  (0, _react.useEffect)(() => {
    if (updateWarnings) {
      updateWarnings(tabId, tabWarnings);
    }
  }, [tabId, tabWarnings, updateWarnings]);
  (0, _react.useEffect)(() => {
    if (updateInfos) {
      updateInfos(tabId, tabInfos);
    }
  }, [tabId, tabInfos, updateInfos]);
  return /*#__PURE__*/_react.default.createElement(TabContext.Provider, {
    value: {
      setError,
      setWarning,
      setInfo
    }
  }, /*#__PURE__*/_react.default.createElement(_tab.default, _extends({
    className: className,
    role: role,
    isTabSelected: isTabSelected,
    "aria-labelledby": ariaLabelledby,
    position: position
  }, (0, _tags.default)("tab", rest), rest), !href && children));
};

Tab.propTypes = { ...paddingPropTypes,
  title: _propTypes.default.string,

  /** A unique ID to identify this specific tab. */
  tabId: _propTypes.default.string.isRequired,

  /** @ignore @private */
  className: _propTypes.default.string,

  /** The child elements of Tab component. */
  children: _propTypes.default.node,

  /** Overrides Title default layout with a one defined in this prop */
  customLayout: _propTypes.default.node,

  /** Boolean indicating selected state of Tab. */
  isTabSelected: _propTypes.default.bool,

  /** The position of the Tab. */
  position: _propTypes.default.oneOf(["top", "left"]),

  /** @ignore @private */
  role: _propTypes.default.string,

  /** @ignore @private */
  ariaLabelledby: _propTypes.default.string,

  /** @ignore @private */
  updateErrors: _propTypes.default.func,

  /** @ignore @private */
  updateWarnings: _propTypes.default.func,

  /** @ignore @private */
  updateInfos: _propTypes.default.func,

  /** Message displayed when Tab has error */
  errorMessage: _propTypes.default.string,

  /** Message displayed when Tab has warning */
  warningMessage: _propTypes.default.string,

  /** Message displayed when Tab has warning */
  infoMessage: _propTypes.default.string,

  /** Additional content to display with title */
  siblings: _propTypes.default.arrayOf(_propTypes.default.node),

  /** Position title before or after siblings */
  titlePosition: _propTypes.default.oneOf(["before", "after"]),

  /** Allows Tab to be a link */
  href: _propTypes.default.string
};
var _default = Tab;
exports.default = _default;